import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useOrderItemsService } from '@/flight-deck-api/services/order-items.service'

export function useAddBudget() {
  const queryClient = useQueryClient()
  const { addBudget } = useOrderItemsService()

  const refreshOffering = async () => {
    // Refresh failures must not replace the purchase error.
    await Promise.allSettled([queryClient.invalidateQueries({ queryKey: ['getOffering'] })])
  }

  return useMutation({
    mutationFn: addBudget.handler,
    retry: false,
    onError: refreshOffering,
    onSuccess: async response => {
      if (response.status !== 200) {
        await refreshOffering()
        return
      }
      // Cache refresh failures cannot change the confirmed purchase outcome.
      await Promise.allSettled([
        queryClient.invalidateQueries({ queryKey: ['orderItems'] }),
        queryClient.invalidateQueries({
          queryKey: ['order-items-aggregated-summary'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['orderItemsStatusSummary'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['getOrderItemByCampaignGroupId'],
        }),
      ])
    },
  })
}
